module.exports = __webpack_public_path__ + "static/media/22-013.56112320.png";